import { Link, useNavigate } from "react-router-dom";
import "./css/CategoryGridd.css";
import { useEffect, useState } from "react";
import { supabase } from "./lib/supabaseClient.ts";

const CategoryGridwebb = () => {
  const [categories, setCategories] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
const navigate = useNavigate();

  useEffect(() => {
    async function fetchCategories() {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .gte("id", 80)
        .lte("id", 87)
        .order("id");

      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        setCategories(data);
      }
    }

    fetchCategories();
  }, []);

  const getImageUrl = (path) => {
    return supabase.storage.from("animalia").getPublicUrl(path).publicURL;
  };

  const openModal = async (category) => {
    setSelectedCategory(category);
    setModalOpen(true);
    const { data, error } = await supabase
      .from("subcategories")
      .select("*")
      .eq("category_id", category.id)
      .order("id");

    if (error) {
      console.error("Error fetching subcategories:", error);
      setSubcategories([]);
    } else {
      setSubcategories(data);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedCategory(null);
    setSubcategories([]);
  };

  return (
    <>

      <div className="grid-wrapper">
        {categories.map((category) => (
       <div
                    key={category.id}
                    className="card"
                    style={{ backgroundImage: `url(${category.image})` }}
                >
            {/* Burger Button */}
            <button className="burger-button" onClick={() => openModal(category)}>
              &#9776;
            </button>

            <div className="card-overlay" onClick={() => {
      navigate(`/category/${category.id}/${encodeURIComponent(category.name)}`);
}}>
              <p className="card-title">{category.name}</p>
                <img
                  src="../figmaAssets/btn.png"
                  alt="Voir plus"
                  className="voir-plus-img"
                />
                <span className="voir-plus-text">Voir plus</span>
            </div>
          </div>         

        ))}
      </div>
      {/* Modal */}
      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedCategory.name} – SousCategories</h2>
            <ul className="subcategory-list">
              {subcategories.length > 0 ? (
                subcategories.map((sub) => (
                  <li key={sub.id}>{sub.name}</li>
                ))
              ) : (
                <li>Aucune sous-catégorie trouvée</li>
              )}
            </ul>
            <button onClick={closeModal} className="close-modal">Fermer</button>
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryGridwebb;
